module.exports = __webpack_public_path__ + "img/ded-stock1.b330ac17.png";